export const DEFAULT_STATE = {
  deviceID: "",
  bluetooth: "",
  proxy: "",
  deviceStatus: "",
  deviceStatusId: "",
  remark: "",
  customerCode: "",
  isAvailable: "",
  lotMonth: "",
};
